export const JOB_TITLES = [
  'Şantiye Şefi',
  'Elektrik Ekip Şefi',
  'Mekanik Ekip Şefi',
  'İnşaat Ekip Şefi',
  'Proje Müdürü',
  'Proje Koordinatörü',
  'Mimar',
  'İç Mimar',
  'Saha Mühendisi',
  'Makine Mühendisi',
  'Planlama Mühendisi',
  'Planlama Şefi',
  'Kontrol Mühendisi',
  'Statik Proje Mühendisi',
  'Mekanik Proje Mühendisi',
  'Elektrik Proje Mühendisi',
  'Kalite Kontrol Mühendisi',
  'Kalite Güvence Şefi',
  'İş Güvenliği Uzmanı',
  'İş Güvenliği Şefi',
  'Teknik Ofis Mühendisi',
  'Teknik Ofis Şefi',
  'Mekanik Formen',
  'Elektrik Formen',
  'Mekanik Mühendisi',
  'Elektrik Mühendisi',
  'Harita Mühendisi',
  'Forma',
  'Ustabaşı',
  'Kaba Yapı Ustası',
  'İnce İşler Ustası',
  'Demir Ustası',
  'Kalıp Ustası',
  'Betoncu',
  'Duvarcı',
  'Sıvacı',
  'Boyacı',
  'Seramik Ustası',
  'Alçı Ustası',
  'Su Tesisat Ustası',
  'Elektrik Ustası',
  'Kaynakçı',
  'Marangoz',
  'Vinç Operatörü',
  'Ekskavatör Operatörü',
  'Beko Loder Operatörü',
  'Greyder Operatörü',
  'Silindir Operatörü',
  'Forklift Operatörü',
  'Kule Vinç Operatörü',
  'Kamyon Şoförü',
  'Pompa Operatörü',
  'Depo Sorumlusu',
  'Satınalma Uzmanı',
  'Lojistik Sorumlusu',
  'Muhasebe Sorumlusu',
  'İnsan Kaynakları Uzmanı',
  'Surveyor',
  'Laboratuvar Teknikeri',
  'Bakım Teknikeri',
  'Güvenlik Görevlisi',
  'Gece Bekçisi',
  'Aşçı',
  'Temizlik Personeli',
  'Amele',
  'Diğer',
];
